export default {
  authorizeActivity: function(userRoles, requiredRoles){
    return userRoles.some(role =>
          requiredRoles.some(rr => rr === role)
      );
  }
}